import { Menu } from "@base-ui/react/menu"
import PropTypes from "prop-types"
import React from "react"

const ColumnSettings = ({ columns, onToggleColumn }) => {
  const toggleableColumns = columns.filter((col) => col.header)

  return (
    <Menu.Root>
      <Menu.Trigger
        aria-label="Column settings"
        className="flex cursor-pointer items-center justify-center rounded bg-transparent p-0 px-1 hover:bg-gray-200"
      >
        <i className="fa-kit fa-settings-cog text-lg text-gray-900" />
      </Menu.Trigger>

      <Menu.Portal>
        <Menu.Positioner
          side="bottom"
          align="end"
          sideOffset={4}
          className="z-[200]"
        >
          <Menu.Popup className="max-h-[50vh] min-w-44 overflow-auto rounded border bg-white py-1 shadow-lg">
            <Menu.Group>
              <Menu.GroupLabel className="px-3 py-2 font-semibold">
                Table Columns
              </Menu.GroupLabel>
              {toggleableColumns.map((col) => (
                <Menu.CheckboxItem
                  key={col.key}
                  checked={!col.hide}
                  onCheckedChange={() => onToggleColumn(col.key)}
                  className="flex w-full cursor-pointer items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                  <Menu.CheckboxItemIndicator
                    keepMounted
                    className="flex h-4 w-4 items-center justify-center rounded border border-gray-300 bg-white text-white data-[checked]:border-blue-600 data-[checked]:bg-blue-600"
                  >
                    <i className="fa-kit fa-sf-check text-[10px]" />
                  </Menu.CheckboxItemIndicator>
                  {col.header}
                </Menu.CheckboxItem>
              ))}
            </Menu.Group>
          </Menu.Popup>
        </Menu.Positioner>
      </Menu.Portal>
    </Menu.Root>
  )
}

ColumnSettings.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      header: PropTypes.string.isRequired,
      hide: PropTypes.bool,
    })
  ).isRequired,
  onToggleColumn: PropTypes.func.isRequired,
}

export default ColumnSettings
